import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  return (
    <div className="min-h-screen pt-16 flex items-center justify-center px-6 bg-[var(--bg-alt)]" data-testid="payment-cancel-page">
      <div className="max-w-md w-full card-elevated p-8 text-center">
        <XCircle size={48} className="text-[var(--text-body)] mx-auto mb-4" />
        <h2 className="text-3xl font-heading font-bold mb-2">Payment Cancelled</h2>
        <p className="text-[var(--text-body)] mb-8">No charges were made.</p>
        <div className="flex gap-4 justify-center">
          <Link to="/dashboard" className="btn-outline" data-testid="back-to-dashboard-btn">Dashboard</Link>
          <Link to="/shop" className="btn-primary" data-testid="continue-shopping-btn">Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
}
